/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional student submission ID for personalized questions
 */
export type AssessmentRequestSubmissionId = string | null;
